import { createSlice } from '@reduxjs/toolkit';

import initialState from './initialState';

const updatedLoadSlice = createSlice({
  name: 'updatedLoad',
  initialState,
  reducers: {
    setUpdatedLoad(state, { payload }) {
      state.load = { ...state.load, ...payload };
    },
    clearUpdatedLoad() {
      return initialState;
    },
  },
});

export const {
  setUpdatedLoad,
  clearUpdatedLoad,
} = updatedLoadSlice.actions;

export default updatedLoadSlice.reducer;
